import { Photos } from './brick/photos';
import { Price } from './brick/price';
import { Location } from './brick/location';
import { Features } from './brick/features';
import { ViewDetails } from './brick/view-details';
import { Tags } from './brick/tags';

export function SheetLarge({
  url,
  photos,
  price,
  currency,
  priceUnit,
  state,
  status,
  mandate,
  term,
  suburb,
  address,
  bedrooms,
  bathrooms,
  garages,
  openParking,
  coveredParking,
  floorSize,
  landSize,
  tags,
  listedAt,
}) {
  return (
    <div className={`property-card property-card_type_sheet property-card_size_large`}>
      <Photos urls={photos} />

      <div className={`property-card__details`}>
        <Tags tags={tags} state={state} mandate={mandate} listedAt={listedAt} />

        <Price
          price={price}
          currency={currency}
          priceUnit={priceUnit}
          status={status}
          term={term}
        />

        <Location
          address={address}
          suburb={suburb}
        />

        <Features
          bedrooms={bedrooms}
          bathrooms={bathrooms}
          garages={garages}
          openParking={openParking}
          coveredParking={coveredParking}
          floorSize={floorSize}
          landSize={landSize}
          withLabels={true}
        />

        <ViewDetails
          url={url}
        />
      </div>
    </div>
  );
}
